import styles from './ReferralBannerMobile.scss';

import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MaterialIcon } from '../MaterialIcon/MaterialIcon';
import { ScrollDirection } from '../NavBar/NavBarUtil';
import { getReferrer } from '../SalesChannel/Util';
import { referralInfo, transformBanner } from './ReferralBannerUtils';

export type Props = {
  mainContentRef?: any;
  navHeight: string;
  paddingTop: string;
  scrollDirection?: ScrollDirection;
  wrapperGroupRef?: any;
  fromJest?: boolean;
};

export const ReferralBannerMobile: React.FC<Props> = ({ fromJest, mainContentRef, navHeight, paddingTop, scrollDirection, wrapperGroupRef }) => {
  const mobileBannerRef = React.createRef<HTMLDivElement>();
  const { t } = useTranslation();
  const [expandSection, setExpandSection] = useState(false);
  const { referrerName, referrerEmail, referrerPhone } = referralInfo(JSON.parse(getReferrer() || '{}'));
  const emailRef = `mailto:${referrerEmail}`;
  const phoneRef = `tel:${referrerPhone}`;
  const expand = () => {
    setExpandSection(!expandSection);
  };
  const translation = fromJest ?
    (
      <>
        <span>your rep</span>
        <span>{referrerName}</span>
      </>
    )
    :
    (
      <Trans i18nKey="your-rep" values={{ referrerName }}>
        <span>your rep</span>
        <span>{referrerName}</span>
      </Trans>
    );
  useEffect(() => {
    const mainContentCurrent = mainContentRef?.current;
    const mobileBannerCurrent = mobileBannerRef.current;
    const wrapperGroupCurrent = wrapperGroupRef?.current;
    if (!mainContentCurrent || !mobileBannerCurrent) return;
    transformBanner(mobileBannerCurrent, mainContentCurrent, navHeight, paddingTop, scrollDirection, wrapperGroupCurrent);
  }, [mobileBannerRef]);

  return (
    <>
      {expandSection && !(scrollDirection === ScrollDirection.DOWN) && (
        <div className={styles.expandedContent}>
          <div className={styles.expandedContentText}>
            {translation}
          </div>
          {referrerEmail && (
            <div className={styles.expandedContentText}>
              <span>{t('email-me-at')}</span>
              <span><a href={emailRef}>{referrerEmail}</a></span>
            </div>
          )}
          {referrerPhone && (
            <div className={styles.expandedContentText}>
              <a className={styles.expandedContentTextPhoneSection} href={phoneRef}>{t('call-me')}</a>
            </div>
          )}
        </div>
      )}
      <div ref={mobileBannerRef} className={styles.referralBanner}>
        <button className={styles.referralBannerContent} onClick={expand}>{t('contact-your-rep')}
          <MaterialIcon className={styles.referralBannerContentCaret} icon={expandSection ? 'expand_less' : 'expand_more'} />
        </button>
      </div>
    </>
  );
};
